import { handleServiceCall } from "@services"
import { ServiceResponse } from "@types"
import axios from "axios"

// =====================
// Type definitions des réponses des services
// =====================
type LoginResponse = string
type GetUserResponse = {
    _id_user: string
    _id_company: string
    plan: string
    subscription_active: boolean
}
// =====================
// Service
// =====================
export class AuthService {
    /**
     * Vérifie si la clé de widget est valide
     * @param key - Clé du widget
     * @returns Le nom de la société et si la clé est valide
     */
    async login(
        username: string,
        password: string
    ): Promise<ServiceResponse["LoginResponse"]> {
        return handleServiceCall<ServiceResponse["LoginResponse"]>(async () => {
            const { data } = await axios.post(
                "/api/metier/signin",
                {
                    username: username,
                    password: password,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-no-authorization": true,
                    },
                }
            )
            return data?.token
        })
    }
    /**
     * Récupère les informations sur le compte de l'utilisateur connecté
     */
    getUser() {
        return handleServiceCall<ServiceResponse["GetUserResponse"]>(
            async () => {
                const { data } = await axios.get("/api/metier/v5/user/me", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                return {
                    _id_user: data?._id,
                    _id_company: data?.company?._id,
                    plan: data?.company?.operation?.stripe?.plan,
                    subscription_active:
                        data?.company?.operation?.stripe?.subscription_active,
                }
            }
        )
    }
}

export type { LoginResponse, GetUserResponse }
